import React from 'react';
import { Text, TextProps } from '@mantine/core';
import { P3Bold as P3BoldStyle } from 'theme/typography';

interface P3BoldProps extends TextProps {
  customStyle?: React.CSSProperties;
  children: React.ReactNode;
}

/**
 * Applies the P3Bold typography style.
 */
const P3Bold: React.FC<P3BoldProps> = ({ children, customStyle, ...restProps }) => {
  return (
    <Text {...restProps} style={{ ...P3BoldStyle, ...customStyle }}>
      {children}
    </Text>
  );
};

export default P3Bold;
